import {
  DELETE_BROTHER_BEGIN,
  DELETE_BROTHER_ERROR,
  DELETE_BROTHER_SUCCESS,
  DELETE_OTHER_IMG_BEGIN,
  DELETE_OTHER_IMG_ERROR,
  DELETE_OTHER_IMG_SUCCESS,
  DELETE_SISTER_BEGIN,
  DELETE_SISTER_ERROR,
  DELETE_SISTER_SUCCESS,
  GET_PROFILE_BEGIN,
  GET_PROFILE_ERROR,
  GET_PROFILE_SUCCESS,
  UPDATE_PROFILE_BEGIN,
  UPDATE_PROFILE_ERROR,
  UPDATE_PROFILE_SUCCESS,
} from "../utils/action";

const Profile_reducer = (state, action) => {
  switch (action.type) {
    case GET_PROFILE_BEGIN:
      return { ...state, profile_loading: true };
    case GET_PROFILE_SUCCESS:
      return { ...state, profile_loading: false, profile_data: action.payload };
    case GET_PROFILE_ERROR:
      return { ...state, profile_loading: false };

    case UPDATE_PROFILE_BEGIN:
      return { ...state, update_loading: true };
    case UPDATE_PROFILE_SUCCESS:
      return { ...state, update_loading: false };
    case UPDATE_PROFILE_ERROR:
      return { ...state, update_loading: false };

    case DELETE_BROTHER_BEGIN:
      return { ...state, delete_Bro_loading: true };
    case DELETE_BROTHER_SUCCESS:
      return { ...state, delete_Bro_loading: false };
    case DELETE_BROTHER_ERROR:
      return { ...state, delete_Bro_loading: false };

    case DELETE_SISTER_BEGIN:
      return { ...state, delete_Sis_loading: true };
    case DELETE_SISTER_SUCCESS:
      return { ...state, delete_Sis_loading: false };
    case DELETE_SISTER_ERROR:
      return { ...state, delete_Sis_loading: false };

    case DELETE_OTHER_IMG_BEGIN:
      return { ...state, delete_other_img_load: true };
    case DELETE_OTHER_IMG_SUCCESS:
      return { ...state, delete_other_img_load: false };
    case DELETE_OTHER_IMG_ERROR:
      return { ...state, delete_other_img_load: false };

    default:
      return state;
  }
};

export default Profile_reducer;
